import {
  getDownloadURL,
  ref,
  uploadBytes,
} from "firebase/storage";
import { normalizeCareFocusSelection } from "../../../constants/childProfileOptions";
import { buildChildProfilePhotoPath } from "./profileFormHelpers";

export const saveChildProfilePhoto = async ({
  storage,
  childId,
  photo,
  fallbackPhotoURL = "",
  buildPhotoPath = buildChildProfilePhotoPath,
  createStorageRef = ref,
  uploadFile = uploadBytes,
  getFileDownloadURL = getDownloadURL,
} = {}) => {
  if (!photo) {
    return fallbackPhotoURL || "";
  }

  const photoRef = createStorageRef(storage, buildPhotoPath(childId, photo));
  await uploadFile(photoRef, photo);
  return getFileDownloadURL(photoRef);
};

export const buildChildProfileSavePayload = ({
  name = "",
  age = "",
  dateOfBirth = "",
  photoURL = "",
  selectedConditions = [],
  medicalProfileUpdate = {},
} = {}) => {
  const normalizedCareFocus = normalizeCareFocusSelection(selectedConditions);
  const primaryLabel = normalizedCareFocus[0]?.label || "";
  const conditionCodes = normalizedCareFocus.map((item) => item.code);

  return {
    name,
    age,
    dateOfBirth,
    photoURL,
    profilePhoto: photoURL,
    diagnosis: primaryLabel,
    concerns: normalizedCareFocus,
    conditionCodes,
    ...medicalProfileUpdate,
  };
};

export const prepareChildProfileSave = async ({
  storage,
  childId,
  photo,
  fallbackPhotoURL = "",
  name = "",
  age = "",
  dateOfBirth = "",
  selectedConditions = [],
  medicalProfileUpdate = {},
  buildPhotoPath,
  createStorageRef,
  uploadFile,
  getFileDownloadURL,
} = {}) => {
  const savedPhotoURL = await saveChildProfilePhoto({
    storage,
    childId,
    photo,
    fallbackPhotoURL,
    ...(buildPhotoPath ? { buildPhotoPath } : {}),
    ...(createStorageRef ? { createStorageRef } : {}),
    ...(uploadFile ? { uploadFile } : {}),
    ...(getFileDownloadURL ? { getFileDownloadURL } : {}),
  });

  return {
    savedPhotoURL,
    updatedChild: buildChildProfileSavePayload({
      name,
      age,
      dateOfBirth,
      photoURL: savedPhotoURL,
      selectedConditions,
      medicalProfileUpdate,
    }),
  };
};
